import {
  loginByAccount,
  loginByEmail,
  updateAvatarById,
  updatePointById,
} from "../../api";

const user = {
  namespaced: true,

  state: () => ({
    token: localStorage.getItem("token") || "",
    loading: false,
    userInfo: JSON.parse(localStorage.getItem("user") || "null") || null,
  }),

  getters: {
    userName: (state) => state.userInfo?.userName || "用户",
    userAvatar: (state) => state.userInfo?.avatar || "",
    isLoggedIn: (state) => !!state.token,
    userId: (state) => state.userInfo?.id,
    points: (state) => state.userInfo?.points || 0,
    invitation: (state) => state.userInfo?.invitation || "",
    email: (state) => state.userInfo?.email || "",
    createTime: (state) => state.userInfo?.createTime || "",
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      if (token) {
        localStorage.setItem("token", token);
      } else {
        localStorage.removeItem("token");
      }
    },

    SET_LOADING(state, loading) {
      state.loading = loading;
    },

    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
      if (userInfo) {
        localStorage.setItem("user", JSON.stringify(userInfo));
      } else {
        localStorage.removeItem("user");
      }
    },

    UPDATE_USER_POINTS(state, { points, addNum }) {
      if (state.userInfo) {
        state.userInfo.points =
          points !== undefined ? points : state.userInfo.points + addNum;
        localStorage.setItem("user", JSON.stringify(state.userInfo));
      }
    },

    CLEAR_USER(state) {
      state.userInfo = null;
      state.token = "";
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
  },

  actions: {
    async loginByEmail({ commit }, { email, code }) {
      try {
        const response = await loginByEmail(email, code);
        const { data } = response;

        commit("SET_LOADING", true);
        commit("SET_TOKEN", data.token);
        commit("SET_USER_INFO", data.user);
        return response;
      } catch (error) {
        console.error("登录失败:", error);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async loginByAccount({ commit }, { account, password }) {
      try {
        const response = await loginByAccount(account, password);
        const { data } = response;

        commit("SET_LOADING", true);
        commit("SET_TOKEN", data.token);
        commit("SET_USER_INFO", data.user);
        return response;
      } catch (error) {
        console.error("登录失败:", error);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async logout({ commit }) {
      commit("CLEAR_USER");
    },

    async checkin({ commit, getters }) {
      try {
        const userId = getters.userId;
        const response = await updatePointById(userId, 1, "每日签到");
        if (response.code === 200) {
          commit("SET_USER_INFO", response.data.user);
          return response;
        } else {
          throw new Error(response.data.message || "签到失败");
        }
      } catch (error) {
        console.error("签到失败:", error);
        throw error;
      }
    },

    // 通用的积分更新方法
    async updatePoints({ commit, getters }, { num, reason }) {
      try {
        const userId = getters.userId;
        if (!userId) {
          throw new Error("用户未登录");
        }

        const response = await updatePointById(userId, num, reason);

        if (response.data.code === 200) {
          // 处理不同的返回数据结构
          const data = response.data.data;

          if (data && data.user) {
            commit("SET_USER_INFO", data.user);
          } else if (data && data.points !== undefined) {
            commit("UPDATE_USER_POINTS", {
              points: data.points,
            });
          } else {
            commit("UPDATE_USER_POINTS", {
              addNum: num,
            });
          }

          return response.data;
        } else {
          throw new Error(response.data.message || "积分更新失败");
        }
      } catch (error) {
        console.error("积分更新失败:", error);
        throw error;
      }
    },

    async updateAvatar({ commit, getters }, file) {
      try {
        const response = await updateAvatarById(getters.userId, file);
        if (response.code === 200) {
          commit("SET_USER_INFO", response.data);
          return response;
        } else {
          throw new Error(response.data.message || "头像上传失败");
        }
      } catch (error) {
        console.error("上传失败:", error);
        throw error;
      }
    },
  },
};

export default user;
